import { atom, selector } from "recoil"
import Lib from 'library'


const headerState = atom({
	key: "headerState",
	default: {}
})

const headerSelector = selector({
	key: "headerSelector",
	get: ({ get }) => {
		return headerState
	},
	set: ({ set }, newValue) => {
		set(headerState, newValue)
	}
})

const showSettingState = atom({
	key: "showSettingLayer",
	default: false
})

//헤더 알림
const showAlertState = atom({
	key: "showAlertLayer",
	default: false
})

const getNotiState = selector({
	key: "getNotiState",
	get: async ({ get }) => {
		const data = await Lib.get("/api/noti")
		const pathname = get(locationState)
		console.log({ pathname })
		if (data?.length > 0) {
			return true
		} else {
			return false
		}
	}
})

const locationState = atom({
	key: "locationState",
	default: "",
	effects: [
		param => {
			console.log(param)
		}
	]
})

const iconState = atom({
	key: "icon",
	default: false
})

export { headerState, headerSelector, showSettingState, getNotiState, locationState, showAlertState, iconState }